export const SW_VERSION = "d660f7d3d7ca2aa76f637b7a1ed258ea";